import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-caso-uso',
  templateUrl: './dialog-delete-caso-uso.component.html',
  styleUrls: ['./dialog-delete-caso-uso.component.css']
})
export class DialogDeleteCasoUsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
